.ageGateform {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal {
  border-radius: 40px;
}

.modalContent {
  background-color: var(--bloom-colors-header-main);
  width: calc(100vw - 48px);
}

.logoContainer {
  display: flex;
  justify-content: center;
}

.logo {
  max-height: 48px;
  max-width: 200px;
}

.message {
  color: var(--bloom-colors-header-contrast);
  text-align: center;
  padding-top: 24px;
  padding-bottom: 24px;
}

.decline {
  background-color: #f2f2f2; /* tertiary color, but opaque */
}

.dobInput {
  text-align: center;
}

.dobInput > p {
  color: var(--bloom-colors-header-contrast);
}

.dobInput > div > div {
  margin-bottom: 24px;
}

/* Center align input text */
.dobInput input {
  text-align: center;
}

@media all and (--reefer-media-tablet-min) {
  .modalContent {
    max-width: 360px;
    padding: 24px;
  }
}
